import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function FinalCTASection() {
  return <section className="bg-brand-dark py-14 md:py-20 relative overflow-hidden" data-id="element-72">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-73">
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-74"></div>
        <div className="absolute top-1/4 -right-24 w-72 h-72 bg-brand-orange rounded-full blur-3xl" data-id="element-75"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-76">
        <FadeIn data-id="element-77">
          <h2 className="text-4xl md:text-6xl font-bold text-brand-cream mb-8 leading-tight" data-id="element-78">
            Tu próxima milhojas puede ser la que todos recuerden
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-79">
          <div className="text-xl md:text-2xl text-brand-cream/80 font-serif italic space-y-6 mb-10 max-w-2xl mx-auto" data-id="element-80">
            <p data-id="element-81">
              Imaginate sacarla del horno, ver esas 12 capas perfectas apiladas,
              poner el merengue brillante encima y escuchar a tu familia o
              clientes decir:
            </p>
            <p className="text-brand-gold font-bold text-2xl md:text-3xl" data-id="element-82">
              '¿Dónde la compraste?'
            </p>
            <p data-id="element-83">
              Ese momento existe. Y está a un método de distancia. Stella lo
              enseñó. Cientos de personas lo lograron. Ahora es tu turno.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-84">
          <CTAButton isPayment className="text-xl md:text-2xl px-8 py-6 md:px-12 md:py-8 mb-8 w-full md:w-auto" data-id="element-85">
            🛒 Sí, quiero aprender el método ahora
          </CTAButton>

          {/* Payment Method Icons */}
          <div className="flex flex-wrap justify-center items-center gap-4 mb-16" data-id="element-86">
            <div className="flex items-center gap-3" data-id="element-87">
              <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-1.5" data-id="element-88">
                <span className="font-bold text-white text-sm tracking-wider" data-id="element-89">
                  VISA
                </span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-1.5" data-id="element-90">
                <div className="flex items-center gap-0.5" data-id="element-91">
                  <div className="w-4 h-4 bg-red-400 rounded-full opacity-80" data-id="element-92"></div>
                  <div className="w-4 h-4 bg-yellow-400 rounded-full -ml-2 opacity-80" data-id="element-93"></div>
                </div>
              </div>
              <div className="bg-white/90 border border-white/30 rounded-lg px-2 py-1" data-id="element-94">
                <img src="https://cdn.magicpatterns.com/uploads/n6Us3NWUWRCkRk1qvu7EUL/pasted-image.png" alt="Mercado Pago" className="h-6 w-auto" data-id="element-95" />
              </div>
              <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-1.5" data-id="element-96">
                <span className="font-bold text-white/90 text-sm" data-id="element-97">
                  Pay<span className="text-[#009CDE]" data-id="element-98">Pal</span>
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-99">
          <div className="mt-12" data-id="element-100">
            <p className="text-brand-gold font-serif italic text-2xl" data-id="element-101">
              Con amor y harina,
            </p>
            <p className="text-brand-cream font-bold text-xl mt-2" data-id="element-102">
              Stella Pereira 🧁
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}